import { Client } from "@bugsnag/browser";
import Home from "components/home";
import LicenseExpired from "components/licenseExpired";
import ErrorBoundary from "components/shared/errorBoundary";
import App from "containers/app";
import Login from "containers/login";
import { paths } from "helpers/paths";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Store } from "redux";

const Root = (props: { store: Store; bugsnagClient?: Client }) => {
    const { store, bugsnagClient } = props;

    if (location.pathname === paths.licenseExpired) {
        return <LicenseExpired />;
    }
    return (
        <ErrorBoundary>
            <Provider store={store}>
                <BrowserRouter>
                    <Switch>
                        <Route path={paths.home} component={Home} />
                        <Login>
                            <Route path="/" render={(props) => <App {...props} bugsnagClient={bugsnagClient} />} />
                        </Login>
                    </Switch>
                </BrowserRouter>
            </Provider>
        </ErrorBoundary>
    );
};

export default Root;
